import React from "react";
import styles from "./landing.module.css";

const Landing = (props) => {
  return (
    <section className={styles.main} id="main">
      <div className={styles["box-content"]}>
        <div className={styles["title"]}>
          <h1>Full Stack Web Developer</h1>
        </div>
        <div className={styles.description} elevation={1}>
          <p>
            Hi!, I'm a Full Stack Developer with React & Nodejs; I have
            collaborated in the development of ecommerce web projects with SQL &
            NoSQL databases and third party auth, also mobile development with
            React Native, Expo & Firebase.
          </p>
          <br />
          <p>
            I'm currently looking for opportunities that allow me to join an
            excellent work group, able to provide solutions and learn new
            technologies, in order to expand and improve my skill.
          </p>
        </div>
      </div>
      <div className={styles["box-image"]}>
        <div className={styles["image"]}>
          <img style={styles.img} src="/me.jpg" alt="" />
        </div>
      </div>
    </section>
  );
};

export default Landing;
